import React, { Component } from "react";
import { Grid, withStyles } from "@material-ui/core";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";

import { styles } from "./styles";
import BannerLabel from "../../components/ui-elements/bannerLabel";
import KooeeContainer from "../../components/ui-elements/kooeeContainer";
import UserBenefits from "../../components/kooeeBenefitsWall/userBenefits";
import HeaderMenu from "../../components/ui-elements/header";
import KooeeBanner from "../../components/ui-elements/banner";
import UserInputs from "../../components/kooeeBenefitsWall/userInputs";
import ExtraBenefits from "../../components/kooeeBenefitsWall/extraBenefits";
import benefitsCalcAction from "../../redux/benefits/actions";

const { getBenefitsAndPayments } = benefitsCalcAction;

const slider = {
  min: 0,
  max: 7,
  default: 0,
  step: 100
};

export class KooeeBenefitsWall extends Component {
  constructor(props) {
    const state = sessionStorage.getItem("state");
    const annualBill = sessionStorage.getItem("annualBill");
    super(props);
    this.state = {
      selectedItems: [],
      depositAmount: 0,
      totalCost: props.benefits.totalCost ? props.benefits.totalCost : 1000,
      bundleAmount: props.benefits.bundleAmount ? props.benefits.bundleAmount : 0,
      annualBill: annualBill ? annualBill : 0,
      stateCode: state ? state : "",
      householdSize: 1,
      hasSolar: false,
      hasBattery: false,
      hasPool: false,
      wasteFactor: 1
    };
    if (Object.entries(props.benefits).length === 0 && props.benefits.constructor === Object) {
      this.goToCalc();
    }
    window.scrollTo(0, 0);
    this.scrollDiv = React.createRef();
  }

  static getDerivedStateFromProps(props, state) {
    return {
      ...state,
      totalCost: props.benefits.totalCost,
      bundleAmount: props.benefits.bundleAmount,
      hasBattery: props.history.location.state.detail ? props.history.location.state.detail.battery : false,
      householdSize: props.history.location.state.detail ? props.history.location.state.detail.headCount : 1,
      hasPool: props.history.location.state.detail ? props.history.location.state.detail.pool : false,
      wasteFactor: props.history.location.state.detail ? props.history.location.state.detail.rating : 4,
      hasSolar: props.history.location.state.detail ? props.history.location.state.detail.solar : false
    };
  }

  componentDidUpdate() {
    if (this.scrollDiv.current) {
      this.scrollDiv.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest"
      });
    }
  }

  componentDidMount() {
    this.setState({
      hasBattery: this.props.history.location.state.detail ? this.props.history.location.state.detail.battery : false,
      householdSize: this.props.history.location.state.detail ? this.props.history.location.state.detail.headCount : 1,
      hasPool: this.props.history.location.state.detail ? this.props.history.location.state.detail.pool : false,
      wasteFactor: this.props.history.location.state.detail ? this.props.history.location.state.detail.rating : 4,
      hasSolar: this.props.history.location.state.detail ? this.props.history.location.state.detail.solar : false
    });
  }

  setDepositAmount = amount => {
    this.setState({
      depositAmount: amount
    });
  };

  selectItems = items => {
    this.setState({
      selectedItems: items
    });
  };

  userBenefitsCalc = (items, deposit) => {
    const { getBenefitsAndPayments } = this.props.actions;
    const { householdSize, hasSolar, hasBattery, hasPool, wasteFactor } = this.state;
    const dataObj = {
      stateCode: this.state.stateCode,
      annualBill: this.state.annualBill,
      smartHome: items.includes("smartHome"),
      battery: items.includes("battery"),
      solar: items.includes("solar"),
      deposit: deposit,
      householdSize: householdSize,
      hasSolar: hasSolar,
      hasBattery: hasBattery,
      hasPool: hasPool,
      wasteFactor: wasteFactor
    };
    getBenefitsAndPayments(dataObj);
  };

  goToCalc = () => {
    this.props.history.push({
      pathname: "/energy-cost-cal",
      state: { resetCalc: true }
    });
  };

  render() {
    const { classes } = this.props;
    const { selectedItems, totalCost, bundleAmount, annualBill } = this.state;
    return (
      <Grid className={classes.root} container direction="column" justifyContent="space-between" alignItems="stretch">
        <Grid item xs>
          <HeaderMenu />
          <KooeeBanner />
          <BannerLabel headerTitle="Savings" subTitle="Adjust the controls and see how much you can save with NRG." />
        </Grid>
        <Grid item xs ref={this.scrollDiv}>
          <KooeeContainer
            content={
              <UserInputs
                sliderProps={slider}
                setDepositAmount={this.setDepositAmount}
                selectItems={this.selectItems}
                selectedItems={selectedItems}
                totalCost={totalCost}
                userBenefitsCalc={this.userBenefitsCalc}
              />
            }
            class={classes.paperClass}
          />
          <KooeeContainer
            content={<UserBenefits items={selectedItems} bundleAmount={bundleAmount} annualBill={annualBill} />}
            class={`${classes.paperClass} ${classes.whiteFont}`}
            rootClass={classes.benefitsDisplay}
          />
          <KooeeContainer content={<ExtraBenefits bundleAmount={bundleAmount} annualBill={annualBill} />} class={classes.paperClass} />
        </Grid>
      </Grid>
    );
  }
}

KooeeBenefitsWall.propTypes = {
  classes: PropTypes.object,
  history: PropTypes.object,
  actions: PropTypes.object,
  stateCode: PropTypes.string,
  estimatedBill: PropTypes.object,
  stateFetching: PropTypes.bool,
  benefits: PropTypes.object,
  benefitsReqObj: PropTypes.object
};

function mapStateToProps(state) {
  return {
    ...state.benefitsReducer.toJS()
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        getBenefitsAndPayments
      },
      dispatch
    )
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(KooeeBenefitsWall));
